import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Footer from '../elements/Footer';
import Accordion from 'react-bootstrap/Accordion';




function Servicepayrollmanagement() {
  return (
    <div className='payroll-management'>
        <div className="">
            <Header/>
            <main>
                <Breadcrumb title="Payroll Management" sub_title="Service" active="Payroll Management"/>
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                            <div className="tmp-large-service-detials">
                                <img
                                src="assets/images/services/payroll-management.jpg"
                                alt="business formation"
                                />
                            </div>
                            {/* single service details component */}
                            <div className="single-service-details-component mt--40">
                                <h2 className="title split-collab">
                                Stress-Free Payroll Solutions for Growing Businesses
                                </h2>
                                <p className="disc mb--20">
                               Partner with us to streamline your payroll operations and ensure your employees are paid accurately and on time. We have successfully helped many businesses by taking care of the details so they can focus on running their business while staying fully compliant with tax and labor regulations.
                                </p>
                                <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Instant Business Growth</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Expert Team Members</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Easy Customer Service</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>24/7 Quality Service</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                </div>
                            </div>
                            {/* single service details component end */}
                            <div className="row g-5 mt--10">
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Precision Payroll Management You Can Trust</h6>
                                    <p className="disc">
                                       We manage every aspect of your payroll with precision and care. Our goal is to help you save time, reduce risk and give your employees the confidence that they’ll be paid correctly – every time.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Stay Compliant, Stay Confident with F.A Accounting</h6>
                                    <p className="disc">
                                       We also stay ahead of regulatory changes, ensuring you stay compliant with latest tax laws and labor requirements. With F.A Accounting you can more than a payroll provider, you gain a reliable partner committed to your long-term success.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                            </div>
                            <div className="row g-5 mt--10">
                                <div className="col-lg-12">
                                <h2 className="title split-collab">
Personalized Payroll Solutions for Every Business</h2>
                                <p className="disc mb--20">
                                  At F.A Accounting and business we understand that every business has unique payroll needs. Whether you have a small team or a growing workforce, we tailor our services to fit your operations. Our dedicated support team is only a call or click away, ready to answer questions, resolve issues and provide peace of mind every step of the way.
                                </p>
                                </div>
                                
                                
                                
                            </div>
                            <div className="row mt--10">
                                <div className="col-lg-12">
                                <div className="faq-accordion">

                                    <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>What does your payroll management service include?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                                </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Our payroll management covers salary processing, tax calculations, direct deposits, compliance reporting, and employee record maintenance. We ensure every payment is accurate and on time while keeping you fully compliant with tax and labor laws.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>Can you handle payroll for both small and large businesses?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                               Yes! Our payroll solutions are scalable — designed to meet the needs of startups, growing companies, and established enterprises. Whether you have 5 employees or 500, we tailor our process to fit your business structure.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>
                                                    How do you ensure accuracy and compliance?
                                                </span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                We use automated systems and perform regular audits to maintain 100% accuracy. Our team stays up to date with state and federal payroll regulations, ensuring your business remains compliant and penalty-free.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>

                                    <div className="faq-buttom">
                                    <h4 className="title">Still Have More Questions?</h4>
                                    <p>
                                                      Contact Our <a style={{color:"#F8E3E3"}} href="/contact-us">Expert Support Team</a>
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                            <div className="side-bar-details-page">
                                
                                {/* single bar */}
                                <div className="signle-side-bar category-area">
                                <div className="header">
                                    <h3 className="title">Service List</h3>
                                </div>
                                <div className="body">
                                    {/* single category */}
                                    <a href="/business-formation" className="single-category">
                                    <p>Business Formation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/book-keeping" className="single-category">
                                    <p>Book Keeping</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/tax" className="single-category">
                                    <p>Tax</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/business-consultation" className="single-category">
                                    <p>Business Consultation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                <div className="signle-side-bar call-to-action">
                                <div className="easy-call-to-action">
                                    <div className="icon-center-call">
                                    <i className="fa-light fa-phone" />
                                    </div>
                                    <h3 className="title">Need any help?</h3>
                                    <p className="disc">
                                    We are here to help our customer any time. You can call on
                                    24/7 To Answer Your Question.
                                    </p>
                                    <a href="tel:8323510418">832-351-0418</a>
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                {/* <div className="signle-side-bar brochure">
                                <div className="header">
                                    <h3 className="title">Brochure</h3>
                                </div>
                                <div className="body">
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Investment Policy</p>
                                    <i className="fa-light fa-cloud-arrow-down" />
                                    </a>
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Company Details</p>
                                    <i className="fa-light fa-note" />
                                    </a>
                                  
                                </div>
                                </div> */}
                                {/* single bar end */}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default Servicepayrollmanagement